<template>
  <div class="form-item-title">
    <div
      class="content flex-align__between"
      :class="{ 'content-bottom-border': showBottomBorder }"
    >
      <div class="flex-align">
        <div v-if="required" class="required-sign">*</div>
        <div class="title" :style="titleStyle">{{ title }}</div>
        <slot name="titleRight"></slot>
      </div>
      <div v-if="showSuccess" class="content-right">
        <i class="el-icon-check"></i>
        <span>审核通过</span>
      </div>
      <div v-else class="content-right">
        <slot name="contentRight"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormItemTitle',

  props: {
    title: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: true
    },
    showSuccess: {
      type: Boolean,
      default: false
    },
    showBottomBorder: {
      type: Boolean,
      default: true
    },
    titleStyle: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.form-item-title {
  padding: 0 24px;

  .content {
    padding: 20px 0;
    font-size: 14px;
    line-height: 1;

    &.content-bottom-border {
      border-bottom: 1px solid $border-color;
    }

    .required-sign {
      padding-top: 4px;
      margin-right: 6px;
      color: $danger-color;
    }

    .title {
      color: $second-text-color;
      font-size: 16px;
      @include text-bold;
    }

    .content-right {
      color: $success-color;

      i {
        margin-right: pixel-to-rem($n: 14);
      }
    }
  }
}
</style>
